export enum TicketPrintSetting {
  Manual = 0,
  OnReceive = 1,
  OnConfirm = 2,
  OnFinish = 3,
  OnPaid = 4,
}

export enum PrintSource {
  ThisDevice = 0,
  AnyDevice = 1,
  ThisDeviceAndOnline = 2,
}
